

define(['angular', 'squid/index', 'xo-beaver/dist/logger'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('fi.messages', ['squid']).factory('$fiMessages', function ($renderContent, $logger) {

        function getContentKeys(hasFi) {
            if (hasFi) {
                return {
                    member: 'payment.processorDeclineMember',
                    generic: 'payment.processorDeclineMemberGeneric',
                    buyerCredit: 'payment.processorDeclineMemberBuyerCredit'
                };
            } else {
                return {
                    member: 'payment.processorDeclineMemberNoFI',
                    generic: 'payment.processorDeclineMemberNoFIGeneric',
                    buyerCredit: 'payment.processorDeclineMemberBuyerCreditNoFI'
                };
            }
        }

        function processorDeclinedMsg(checkoutSession, hasFi) {
            var declinedInstruments = checkoutSession.get('declinedInstruments');

            if (angular.isArray(declinedInstruments) && declinedInstruments.length) {
                var msg;
                var type = 'warning';
                var instrument = declinedInstruments[0];
                var contentKeys = getContentKeys(hasFi);

                if (instrument.type === 'PAYMENT_CARD') {
                    if (instrument.card_type && instrument.last4) {
                        $logger.info('processor_decline', { hasFi: hasFi, message: 'member' });

                        msg = $renderContent(contentKeys.member, {
                            type: instrument.card_type,
                            number: instrument.last4
                        });
                    } else {
                        $logger.info('processor_decline', { hasFi: hasFi, message: 'generic' });

                        msg = $renderContent(contentKeys.generic);
                    }
                } else {
                    $logger.info('processor_decline', { hasFi: hasFi, message: 'buyerCredit' });

                    msg = $renderContent(contentKeys.buyerCredit);
                }

                checkoutSession.set('declinedInstruments', null);
                return {
                    type: type,
                    msg: msg
                };
            }
        }

        function getAddCardControlMsg() {
            $logger.info('checkout_fpti', {
                'int_error_description': 'addcard_msg_control'
            });
            return {
                msg: $renderContent('creditcard.noFIContingency'),
                type: 'info'
            };
        }

        function getAddCardTreatmentMsg(checkoutSession) {
            var msg;
            var type;
            var title;
            var cardList;
            var lastCard;
            var disallowedInstruments = checkoutSession.get('fundingOptions').get('disallowedInstruments');

            if (disallowedInstruments && disallowedInstruments.length === 1) {
                cardList = disallowedInstruments[0].name + '-' + disallowedInstruments[0].lastDigits;
                $logger.info('checkout_fpti', {
                    'int_error_description': 'single_disallowed_FI_addcard_msg'
                });

                msg = $renderContent('creditcard.hasSingleDisallowedFi', { cardList: cardList });
                type = 'normal';
                title = $renderContent('creditcard.hasDisallowedAddCardTitle');
            } else if (disallowedInstruments && disallowedInstruments.length > 1) {
                cardList = '';

                for (var i = 0; i < disallowedInstruments.length; i++) {
                    if (i === disallowedInstruments.length - 1) {
                        lastCard = disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits;
                    } else if (i === disallowedInstruments.length - 2) {
                        cardList += disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits;
                    } else {
                        cardList += disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits + ', ';
                    }
                }

                $logger.info('checkout_fpti', {
                    'int_error_description': 'multi_disallowed_FI_addcard_msg'
                });

                msg = $renderContent('creditcard.hasMultipleDisallowedFi', { cardList: cardList, lastCard: lastCard });
                type = 'normal';
                title = $renderContent('creditcard.hasDisallowedAddCardTitle');
            } else {
                $logger.info('checkout_fpti', {
                    'int_error_description': 'has_no_FI_addcard_msg'
                });

                msg = $renderContent('creditcard.hasNoDisallowedFi');
                type = 'normal';
                title = $renderContent('creditcard.noDisallowedAddCardTitle');
            }
            return {
                msg: msg,
                type: type,
                title: title
            };
        }

        function getGamblingMsg() {
            return {
                type: 'error',
                msg: $renderContent('creditcard.noEligibleFI')
            };
        }

        return {
            processorDeclinedMsg: processorDeclinedMsg,
            getGamblingMsg: getGamblingMsg,
            getAddCardTreatmentMsg: getAddCardTreatmentMsg,
            getAddCardControlMsg: getAddCardControlMsg

        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/fi/lib/fiMessages.js
// module id = ./components/xo-models/src/fi/lib/fiMessages.js
// module chunks = 1